import { Component, OnInit, EventEmitter } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { LineUserService } from '../../../_services/line-user.service';
import { ElementRef, ViewChild } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
    selector: 'app-add-line-user',
    templateUrl: './add-line-user.component.html',
    styleUrls: ['./add-line-user.component.css']
})
export class AddLineUserComponent extends DialogComponent<null, boolean> implements OnInit {

    @ViewChild('fileInput') fileInput: ElementRef;
    form: FormGroup;
    model: any = {};
    loading = false;
    loadingUpload = false;
    message: string;
    returnUrl: string;
    focusEventEmitter = new EventEmitter<boolean>();
    targetFiles = false;
    lineBotIds: any[] = [];
    fileValid = false;

    constructor(
        dialogService: DialogService,
        private lineUserService: LineUserService,
        private fb: FormBuilder,
    ) {
        super(dialogService);
        this.createForm();
        //disabled button send_mail
        $('#send_mail').attr('disabled', 'disabled');
    }

    //create from
    createForm() {
        this.form = this.fb.group({
            file_emails: ['', Validators.required]
        });
    }

    //on file change, transfer into a var event
    onFileChange(event) {
        //declare var message is empty string
        this.message = '';

        //init var reader
        let reader = new FileReader();

        //if isset files & length > 0 
        if(event.target.files 
            && event.target.files.length > 0
        ) {
            //set targetFiles is true
            this.targetFiles = true;

            //get info file from first element in array
            let file = event.target.files[0];

            //read url of file
            reader.readAsDataURL(file);

            //load file
            reader.onload = () => {
                //set value for file_emails in form
                this.form.get('file_emails').setValue({
                    filename: file.name,
                    filetype: file.type,
                    value: reader.result.split(',')[1]
                });
            };
        } else {
            this.fileValid = false;

            //set targetFiles is false
            this.targetFiles = false;

            //disabled button send_mail
            $('#send_mail').attr('disabled', 'disabled');
        }        
    }

    onSubmit() {
        //declare var message is empty string
        this.message = '';

        //if no files to upload
        if(this.targetFiles === false){
            this.fileValid = false;

            //disabled button send_mail
            $('#send_mail').attr('disabled', 'disabled');

            //assign loadingUpload is false
            this.loadingUpload = false;

            //assign message
            this.message = 'No files to upload !';
            return;
        }
        
        //declare formModel
        const formModel = this.form.value;

        //assign loadingUpload is true
        this.loadingUpload = true;

        setTimeout(() => {
            //assign loadingUpload is false
            this.loadingUpload = false;
            this.lineUserService.upload(
                formModel
            ).subscribe(
                res => {
                    if(res.error === false){
                        //enabled button send_mail
                        this.fileValid = true;
                        if (this.model.line_bot_id) {
                            $('#send_mail').removeAttr('disabled');
                        }

                        //assign value file_name response to file_name of model
                        this.model.file_name = res.file_name;
                    } else {
                        this.fileValid = false;

                        //disabled button send_mail
                        $('#send_mail').attr('disabled', 'disabled');
                        
                        //assign message
                        this.message = 'This is not an csv file! Please check it.';
                    }
                }
            );
        }, 1000);
    }

    ngOnInit() {}

    ngAfterViewInit() {
        this.focusEventEmitter.emit(true);
    }
    
    onChange(event) {
        this.model.line_bot_id = event.target.value;
        if (this.fileValid) {
            $('#send_mail').removeAttr('disabled');
        }
    }
    
    add() {
        //declare var message is empty string
        this.message = '';

        //assign loading is true
        this.loading = true;
        
        this.lineUserService.add(this.model).subscribe(
            data => {
                //assign loading is false
                this.loading = false;

                //if error is true
                if (data.error == true) {
                    //alert message
                    alert(data.message);
                } else {    
                    //alert success
                    alert('Send mail invite success !');
                }

                //close modal
                this.close();
            }
        );
    }

}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/line-user/add-line-user/add-line-user.component.ts